<div class="login-container">

    <a routerLink="/support" class="login-support-link" title="Support">
        <i class="ri-question-line"></i>
    </a>

    <!-- Background: right panel (rotated 12deg) -->
    <div class="bg-panel-right-wrap">
        <div class="bg-panel-right-inner">
            <div class="dot-bg">
                <img src="assets/images/dot-pattern.png" class="dot-img" alt="" />
                <div class="dot-gradient-right"></div>
            </div>
        </div>
    </div>

    <!-- Background: left panel (rotated 162deg, flipped) -->
    <div class="bg-panel-left-wrap">
        <div class="bg-panel-left-inner">
            <div class="dot-bg">
                <img src="assets/images/dot-pattern.png" class="dot-img" alt="" />
                <div class="dot-gradient-left"></div>
            </div>
        </div>
    </div>

    <!-- Logo Section -->
    <div class="logo-section">
        <div class="logo-img-wrap">
            <img src="assets/images/tmeic-logo-tagline.png" alt="TMEIC" class="company-logo" />
        </div>
    </div>

    <!-- Main Content -->
    <div class="login-content">

        <!-- Welcome -->
        <div class="welcome-section">
            <p class="welcome-text">Welcome to <span class="accent-text">Navigator</span></p>
            <p class="welcome-subtitle">Sign in with your Microsoft account to continue</p>
        </div>

        <!-- SSO Button -->
        <div class="sso-section">
            <button type="button" class="sso-button" (click)="onSSOLogin()" [disabled]="ssoLoading">
                <img src="assets/images/microsoft-icon.svg" class="ms-icon" alt="" />
                <span>Continue with Microsoft SSO</span>
            </button>
        </div>

        <!-- Loading State -->
        @if (ssoLoading) {
        <div class="loading-state">
            <i class="pi pi-spin pi-spinner loading-spinner"></i>
            <span class="loading-text">Authenticating with Microsoft</span>
        </div>
        }

    </div>

    <!-- Footer -->
    <div class="login-footer-note">
        <p>Sign in with your Microsoft account to access Navigator Web.</p>
        <p>Navigator Web uses secure Microsoft Entra ID authentication</p>
    </div>

</div>
